"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ausonia": {
    "73954ac6": [{
      "hkey": "a15a7845",
      "slug": "ausonia",
      "name": "Ausonia",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-del-piano": [{
      "hkey": "a15a7845",
      "slug": "ausonia",
      "name": "Ausonia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a8172e5a": [{
      "hkey": "e7c5476a",
      "slug": "selvacava",
      "name": "Selvacava",
      "primary": true,
      "skipSearch": false
    }],
    "sevacava": [{
      "hkey": "e7c5476a",
      "slug": "selvacava",
      "name": "Selvacava",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;